module.exports = __webpack_public_path__ + "static/media/education-object-0-0-0.06b04f4d.png";